module.exports = __webpack_public_path__ + "img/about_2.17a90063.png";